import { render } from "./WalletVerification.vue?vue&type=template&id=09bcd4a5&scoped=true"
import script from "./WalletVerification.vue?vue&type=script&lang=js"
export * from "./WalletVerification.vue?vue&type=script&lang=js"

import "./WalletVerification.vue?vue&type=style&index=0&id=09bcd4a5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bcd4a5"]])

export default __exports__